import React from 'react';
import { createRoot } from 'react-dom/client';

import { CoreLayout } from 'containers';

import 'styles/index.scss';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <CoreLayout />
  </React.StrictMode>,
);
